/* eslint-disable import/prefer-default-export */
import React from 'react';
import { FILTER_TYPE } from 'helpers/constants';
import { ReactComponent as FilterIcon } from 'assets/icons/New/filter-icon.svg';
import { ReactComponent as StatusIcon } from 'assets/icons/New/status-icon.svg';
import { ReactComponent as RatingIcon } from 'assets/icons/New/rating-icon.svg';

export const ICON_MAPPING = {
  [FILTER_TYPE.FILTER]: <FilterIcon />,
  [FILTER_TYPE.STATUS]: <StatusIcon />,
  [FILTER_TYPE.RATING]: <RatingIcon />,
};